import styled from 'styled-components'

const FacebookCommentsPlaceholderUi = styled.img`
  object-fit: scale-down;
`

export default FacebookCommentsPlaceholderUi
